import { render, staticRenderFns } from "./PassiveTask.vue?vue&type=template&id=1dbf6e90&scoped=true&"
import script from "./PassiveTask.vue?vue&type=script&lang=js&"
export * from "./PassiveTask.vue?vue&type=script&lang=js&"
import style0 from "./PassiveTask.vue?vue&type=style&index=0&id=1dbf6e90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf6e90",
  null
  
)

export default component.exports